import { useEffect, useState } from "react";
import { History } from "lucide-react";
import { api, fmtDate } from "@/lib/api";

export const liveSections = (ev) => [
  ["overview", "Summary, what's known and not known"],
  ...(ev.brief_kind === "country" ? [["key_facts", "Key facts and figures"], ["budget", "Budget figures"], ["topics", "Election topics and Middle perspectives"], ["results", "Election night results"]] : []),
  ...(ev.brief_kind && ev.brief_kind !== "country" ? [["brief", "Issue figures and positions"]] : []),
];

// Transparency: what members' confirmed corrections changed here (no names).
export const LiveCorrections = ({ liveId }) => {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get(`/live/${liveId}/corrections`).then((r) => setRows(r.data.items)).catch(() => {}); }, [liveId]);
  if (!rows.length) return null;
  return (
    <details className="rounded-xl border border-border bg-white p-3 text-sm" data-testid="live-corrections">
      <summary className="flex cursor-pointer items-center gap-2 font-medium"><History size={14} />{rows.length} correction{rows.length === 1 ? "" : "s"} from members, confirmed by approved sources</summary>
      <p className="mt-1 text-xs font-medium text-slate-600">Corrected figures stay in place until newer official data arrives.</p>
      <div className="mt-2 space-y-2">{rows.map((c) => (
        <div key={c.id} className="border-t border-border pt-2 text-xs text-slate-600" data-testid={`live-correction-${c.id}`}>
          <p><b>{c.section_label}</b> · {fmtDate(c.checked_at)}</p>
          {c.changes.map((ch, i) => <p key={i}><s>{String(ch.old)}</s> → <b>{String(ch.new)}</b></p>)}
          {c.reason && <p className="text-slate-500">{c.reason}</p>}
        </div>))}</div>
    </details>
  );
};
